import AdsPlayerStateContext from './AdsPlayerState';
import AdsPlayerStateProvider from './AdsPlayerStateProvider';

export default {
  Context: AdsPlayerStateContext,
  Provider: AdsPlayerStateProvider,
  Consumer: AdsPlayerStateContext.Consumer,
};
